<script lang="ts" setup>
defineProps<{
  post: Post.Info
}>()
</script>

<template>
  <div class="m-post-card">
    <div class="m-post-card__category">
      {{ post.category.parent_name || post.category.parent_category?.name }}
      /
      {{ post.category.name }}
    </div>
    <m-link
      :resource-id="post.id"
      :resource-type="post.type"
      :title="post.title"
    >
      <div class="m-post-card__title">{{ post.title }}</div>
      <m-text ellipsis secondary>
        {{ post.summary }}
      </m-text>
      <div v-if="post.cover" class="m-post-card__cover">
        <m-img :src="post.cover" :alt="post.title" :title="post.title" />
      </div>
    </m-link>
    <div class="m-post-card__meta">
      <span class="m-post-card__meta-tag">
        <m-tag
          v-for="tag in post.tag.slice(0, 5)"
          :key="tag"
          size="md"
          :label="tag"
          link
        />
      </span>
      <span class="m-post-card__meta-item">
        {{ post.type === 0 ? '浏览量' : '播放量' }}
        {{ pipe.num(post.view_count) }}
      </span>
      <span class="m-post-card__meta-item">
        评论
        {{ pipe.num(post.comment_count) }}
      </span>
      <span class="m-post-card__meta-item">
        喜欢
        {{ pipe.num(post.like_count) }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-post-card {
  border-bottom: 1px solid var(--color-gray-200);
  margin-bottom: 24px;
  content-visibility: auto;
  contain-intrinsic-size: 400px;
  &__category {
    margin-bottom: 12px;
    font-size: 14px;
    color: var(--color-gray-400);
  }
  &__content {
    display: flex;
  }
  &__cover {
    img {
      width: 240px;
      height: 135px;
      object-fit: cover;
      border-radius: 4px;
    }
  }
  &__info {
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
  }
  &__title {
    font-size: 16px;
    font-weight: 600;
    color: var(--color-gray-800);
    margin-bottom: 10px;
  }
  &__summary {
    font-size: 14px;
    color: var(--color-gray-500);
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  &__meta {
    padding: 20px 0;
    display: flex;
    &-tag {
      margin-right: auto;
    }
    &-item {
      margin-right: 14px;
      display: flex;
      align-items: center;
      color: var(--color-gray-400);
      font-size: 12px;
      user-select: none;
    }
  }
}
</style>
